// src/components/admin/AdminSnackbar.tsx
import React from "react";
import { Snackbar, Alert } from "@mui/material";

export interface AdminSnackState {
  msg: string;
  severity: "success" | "error";
}

interface AdminSnackbarProps {
  snack: AdminSnackState | null;
  onClose: () => void;
}

const AdminSnackbar: React.FC<AdminSnackbarProps> = ({ snack, onClose }) => {
  return (
    <Snackbar
      open={Boolean(snack)}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      {snack ? (
        <Alert severity={snack.severity} onClose={onClose} sx={{ width: "100%" }}>
          {snack.msg}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};

export default AdminSnackbar;

